import { Center, Grid, Switch, Text, NumberInput } from '@mantine/core';
import { MAX_REPORTS_TOTAL } from 'utils/general';
import { IndicatorLabel } from 'components/IndicatorLabel';
import { getHeartRhythmIndicatorLabel } from 'utils/measurement';
import { reportMeasurementIndicators } from 'utils/reports';
import { Fragment } from 'react';
import { UseFormReturnType } from '@mantine/form';
import { ReportContentValues } from 'models/report';
import { Indicator } from 'utils/models';

interface Props<T> {
  form: UseFormReturnType<T>;
  disabled: boolean;
}

export const ReportContentForm = <T extends { reportContent: ReportContentValues; reportsTotal: number }>({
  form,
  disabled,
}: Props<T>) => {
  const { reportsTotal, reportContent } = form.getValues();
  const handleReportContentChecked = (checked: boolean, indicator: Indicator) => {
    if (checked && reportsTotal === MAX_REPORTS_TOTAL) return;
    form.setFieldValue(`reportContent.${indicator}`, (checked ? 1 : 0) as any); // no other way to fix for now
  };

  return (
    <Grid gutter={10}>
      <Grid.Col offset={3} span={7}>
        <Text
          ta={'center'}
          fw={'bold'}
          size={'xs'}
          c={!form.isValid('reportsTotal') ? 'var(--mantine-color-red-5)' : ''}
        >{`${reportsTotal ?? 0}/${MAX_REPORTS_TOTAL}`}</Text>
      </Grid.Col>
      {reportMeasurementIndicators.map((indicator) => (
        <Fragment key={indicator}>
          <Grid.Col span={7}>
            <IndicatorLabel indicator={indicator} label={getHeartRhythmIndicatorLabel(indicator)} />
          </Grid.Col>
          <Grid.Col span={3}>
            <Center>
              {reportContent && indicator && (
                <NumberInput
                  min={0}
                  max={MAX_REPORTS_TOTAL - reportsTotal + reportContent[indicator]}
                  clampBehavior={'strict'}
                  {...form.getInputProps(`reportContent.${indicator}`)}
                  key={form.key(`reportContent.${indicator}`)}
                  disabled={disabled}
                  allowNegative={false}
                  decimalScale={0}
                  allowLeadingZeros={false}
                />
              )}
            </Center>
          </Grid.Col>
          <Grid.Col span={2}>
            {reportContent && indicator && (
              <Switch
                mt={5}
                checked={reportContent[indicator] > 0}
                onChange={(event) => handleReportContentChecked(event.currentTarget.checked, indicator)}
                disabled={disabled}
              />
            )}
          </Grid.Col>
        </Fragment>
      ))}
    </Grid>
  );
};
